export enum MUTATION_KEYS {
  CREATE_VIEW = 'CREATE_VIEW',
  UPDATE_VIEW = 'UPDATE_VIEW',
  DELETE_VIEW = 'DELETE_VIEW',
}

export default MUTATION_KEYS
